// Query-key factory for the staff Portal Accounts registry (the list page
// at /admin/portal-accounts). Backs `portalAccountsApi.list(…)` via React
// Query. Required by the stale-after-save gate (queryKey literals must
// live in *Keys factory files).

export interface PortalAccountsListKeyParams {
  accountType?: string;
  search?: string;
  status?: string[];
  assignedToUserId?: string;
  sortBy?: string;
  sortDir?: string;
  dateField?: string;
  from?: string;
  to?: string;
  awaitingReviewOnly?: boolean;
  overdueOnly?: boolean;
  noActivityDays?: number;
  includeArchived?: boolean;
  page?: number;
}

export const portalAccountsKeys = {
  all: () => ["portal-accounts"] as const,
  list: (params: PortalAccountsListKeyParams) =>
    ["portal-accounts", "list", params] as const,
};
